import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix Resend Password icon. Exported from Figma (Bombiix 2026). */
const ResendPasswordIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      d="M3.33301 9.99935C3.33301 7.48519 3.33301 6.22811 4.11406 5.44706C4.8951 4.66602 6.15218 4.66602 8.66634 4.66602H11.333C13.8472 4.66602 15.1042 4.66602 15.8853 5.44706C16.6663 6.22811 16.6663 7.48519 16.6663 9.99935C16.6663 12.5135 16.6663 13.7706 15.8853 14.5516C15.1042 15.3327 13.8472 15.3327 11.333 15.3327H8.66634C6.15218 15.3327 4.8951 15.3327 4.11406 14.5516C3.33301 13.7706 3.33301 12.5135 3.33301 9.99935Z"
      stroke="currentColor"
    />
    <path
      d="M6 7.33398L7.43926 8.53337C8.66369 9.55372 9.2759 10.0639 10 10.0639C10.7241 10.0639 11.3363 9.55372 12.5607 8.53337L14 7.33398"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </svg>
);

export default ResendPasswordIcon;
